/** FAQ の i18n キー定義。アコーディオン表示と FAQPage JSON-LD で同一の内容を使うための単一の正本。 */
export const butlerSchoolFaqKeys: { q: string; a: string }[] = [
  { q: 'butlerSchool.faq.q1', a: 'butlerSchool.faq.a1' },
  { q: 'butlerSchool.faq.q2', a: 'butlerSchool.faq.a2' },
  { q: 'butlerSchool.faq.q3', a: 'butlerSchool.faq.a3' },
  { q: 'butlerSchool.faq.q4', a: 'butlerSchool.faq.a4' },
  { q: 'butlerSchool.faq.q5', a: 'butlerSchool.faq.a5' },
];
